
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import { GroupLeaderRequest } from "@/types/admin-requests";

interface PendingActionsProps {
  request: GroupLeaderRequest;
  processingId: string | null;
  onApprove: (request: GroupLeaderRequest) => Promise<void>;
  onReject: (request: GroupLeaderRequest) => Promise<void>;
}

export const PendingActions = ({
  request,
  processingId,
  onApprove,
  onReject,
}: PendingActionsProps) => {
  const isProcessing = !!processingId;
  const isCurrentProcessing = processingId === request.id;

  return (
    <div className="flex justify-end gap-2">
      <Button
        variant="outline"
        onClick={() => onReject(request)}
        disabled={isProcessing}
      >
        {isCurrentProcessing ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <XCircle className="h-4 w-4 mr-2" />
        )}
        Avslå
      </Button>
      <Button
        onClick={() => onApprove(request)}
        disabled={isProcessing}
      >
        {isCurrentProcessing ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <CheckCircle className="h-4 w-4 mr-2" />
        )}
        Godkänn
      </Button>
    </div>
  );
};
